/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1YKVNsdnbC%7Bopacity%3A0%7D");
import { type KeyboardEvent, type MouseEvent, useState } from 'react';
import { useIntl } from 'react-intl';
import IconButton from '@atlaskit/button/icon/button';
import { cx } from '@atlaskit/css';
import StarIconMigration from '@atlaskit/icon/core/star-starred';
import StarUnstarredIconMigration from '@atlaskit/icon/core/star-unstarred';
import { Box } from '@atlaskit/primitives/compiled/box';
import messages from './messages';
const styles = {
  hidden: "_1YKVNsdnbC"
};
export const StarIconButton = ({
  isStarred,
  handleToggle,
  visible = true,
  agentName
}: {
  isStarred: boolean;
  handleToggle: (e: MouseEvent<Element, globalThis.MouseEvent> | KeyboardEvent<Element>) => void;
  visible?: boolean;
  agentName: string;
}): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  const [isHovered, setIsHovered] = useState(false);
  return <Box xcss={cx(!visible && styles.hidden)}>
			<IconButton appearance="subtle" spacing="compact" icon={iconProps => isStarred || isHovered ? <StarIconMigration {...iconProps} color={"var(--ds-icon-accent-orange, #E06C00)"} /> : <StarUnstarredIconMigration {...iconProps} color={"var(--ds-icon, #292A2E)"} />} label={formatMessage(isStarred ? messages.removeFromFavouritesLabel : messages.clickToFavouriteLabel, {
      agentName
    })} onClick={handleToggle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} />
		</Box>;
};